import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef } from "react"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
} from "reactstrap"

import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar"
import TablePrimaryComponent from './Components/TablePrimaryComponent'

const IndexView = (props) => {

    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();
    const inactiveRef = useRef();

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <PegawaiSideBar active={`cuti`} />
                        
                        <Card className="pegawai-rightbar">
                            <CardBody>
                                {/* <div className="float-end">
                                {
                                    (accessRole('create')) ?
                                        <Link to="?cuti&create">
                                            <Button color="primary">Pengajuan Cuti</Button>
                                        </Link>
                                    : null
                                }
                                </div> */}
                                <CardTitle>Daftar Cuti</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Kelola Daftar Cuti
                                </CardSubtitle>
                                <hr />
                                <TablePrimaryComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                           </CardBody>
                        </Card>

                    </Col>
                </Row>
            </Container>
        </Fragment>
    )

}


export default IndexView